import { Reducer } from "redux";

import { Components, Enums, Types } from "@sendum/core";

import { TFilter } from "../types/TFilter";

import { DispatchAction } from "./ShipmentSelectorStore";
import { ShipmentSelectorActionTypes } from "./ShipmentSelectorActions";

export interface IShipmentSelectorState {
	error?: Error;
	shipments: Types.TSmallShipment[];
	isFiltering?: boolean;
	countsFilter?: Components.Counts.ECountsItem;
	search?: string;
	filter: TFilter;
	limit?: number;
	isInitialLoading?: boolean;
	isLoading?: boolean;
	total?: number;
	query?: Partial<Types.TLoadShipmentsQuery>;
	isReadOnly?: boolean;
}

const initialState: IShipmentSelectorState = {
	countsFilter: Components.Counts.ECountsItem.TOTAL,
	search: "",
	isInitialLoading: true,
	isLoading: false,
	shipments: [],
	filter: {
		selected: undefined,
		list: [],
		sortBy: "MasterTrackingNo",
		sortOrder: Enums.SortDirection.ASC,
	},
	limit: 10,
};

export const ShipmentSelectorReducer: Reducer<IShipmentSelectorState, DispatchAction> = (state = initialState, action) => {
	switch (action.type) {
		case ShipmentSelectorActionTypes.RESET_STATE: {
			return { ...initialState };
		}
		case ShipmentSelectorActionTypes.SET_COUNTS_FILTER: {
			return { ...state, ...{ countsFilter: action.payload.countsFilter } };
		}
		case ShipmentSelectorActionTypes.SET_SEARCH: {
			return { ...state, ...{ search: action.payload.search } };
		}
		case ShipmentSelectorActionTypes.SET_FILTER: {
			const delta: Partial<IShipmentSelectorState> = { filter: action.payload.filter };

			return { ...state, ...delta };
		}
		case ShipmentSelectorActionTypes.SET_LIMIT: {
			return { ...state, ...{ limit: action.payload.limit } };
		}
		case ShipmentSelectorActionTypes.SET_QUERY: {
			return { ...state, ...{ loadDevicesQuery: action.payload.query } };
		}
		case ShipmentSelectorActionTypes.SET_LOADING: {
			return { ...state, ...{ isLoading: action.payload.isLoading } };
		}
		case ShipmentSelectorActionTypes.END_INITIAL_LOADING: {
			return { ...state, ...{ isInitialLoading: false } };
		}
		case ShipmentSelectorActionTypes.SET_FILTERING: {
			return { ...state, ...{ isFiltering: action.payload.isFiltering } };
		}
		case ShipmentSelectorActionTypes.SET_TOTAL: {
			return { ...state, total: action.payload.total };
		}
		case ShipmentSelectorActionTypes.SET_ERROR: {
			return { ...state, error: action.payload.error };
		}
		case ShipmentSelectorActionTypes.CLEAR_SHIPMENTS: {
			return { ...state, shipments: [] };
		}
		case ShipmentSelectorActionTypes.ADD_SHIPMENTS: {
			return { ...state, shipments: [...(state.shipments ?? []), ...(action.payload.shipments ?? [])] };
		}
		case ShipmentSelectorActionTypes.SET_READONLY: {
			return { ...state, ...{ isReadOnly: action.payload.isReadOnly } };
		}
		default:
			return state;
	}
};
